import { inject, Injectable } from '@angular/core';

import { Chart } from 'chart.js';

import { CHART_JS_REF } from 'landlord/core/chart/chart-js-ref.token';

@Injectable()
export class ChartAdapterService {
  private chartRef = inject(CHART_JS_REF);

  public init() {
    /* eslint-disable @typescript-eslint/no-unsafe-call */
    this.chartRef.pluginService.register({
      afterDraw: function (chart) {
        const yScale = chart.scales['y-axis-0'];
        const helpers = Chart.helpers;
        const chartArea = chart.chartArea;

        // draw the grid lines - simplified version of library code
        yScale.ctx.save();
        helpers.each(
          yScale.ticks,
          function (label, index) {
            if (label === undefined || label === null) {
              return;
            }

            let yLineValue = this.getPixelForTick(index);
            yLineValue += helpers.aliasPixel(this.ctx.lineWidth);

            this.ctx.lineWidth = this.options.gridLines.lineWidth;
            this.ctx.strokeStyle = 'rgba(0, 0, 0, 0.1)';

            this.ctx.beginPath();
            this.ctx.moveTo(Number(chartArea.left) + 10, yLineValue);
            this.ctx.lineTo(chartArea.right, yLineValue);
            this.ctx.stroke();
          },
          yScale
        );
        yScale.ctx.restore();
      }
    });
    /* eslint-enable @typescript-eslint/no-unsafe-call */
  }
}
